import React from "react";
import { CircularProgress, Fab } from "@material-ui/core";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import { DEVICES } from "../../constants";
import { getIframeURL } from "../../utils";
import style from "./style.module.css";
import { DummyBrowserTabDesign } from "common/Components/DummyBrowserTabDesign/DummyBrowserTabDesign";
import { getCreatorHostsiteURL } from "features/Account/utils/getCreatorPageDetails";
import { WhiteLabeledFooter } from "features/WhiteLabeledFooter/WhiteLabeledFooter";
import {
  UNLOCK_WHITELABELED_MESSAGES,
  WHITELABELED_FOOTER,
} from "features/WhiteLabeledFooter/constants/WhiteLabeledFooter.constants";

const RenderHostPage = (props) => {
  const {
    isFrameLoaded,
    initialState,
    device,
    stateForRender,
    templateKey,
    reloadPreview,
    handleFrameLoad,
    handleScrollToPreview,
  } = props;

  return (
    <div className={style.mainContent}>
      {isFrameLoaded ? null : (
        <div className={style.frameLoading}>
          <CircularProgress color="secondary" />
          <br />
          <h3>Loading Preview</h3>
        </div>
      )}

      {initialState?.sub_domain ? (
        <div
          className={`${style.previewBrowser} ${
            device === DEVICES.DESKTOP ? "" : style.mobilePreviewBrowser
          }`}
        >
          <DummyBrowserTabDesign
            mobileDesign={device === DEVICES.MOBILE}
            browserUrl={<>{getCreatorHostsiteURL()?.url}</>}
            faviconUrl={
              stateForRender?.social_info?.favicon ||
              stateForRender?.display_image
            }
            faviconHoverTitle={
              stateForRender?.social_info?.favicon
                ? "Tab Icon is being used"
                : "No tab icon has been uploaded so the display picture is being used"
            }
            onRefreshClick={reloadPreview}
            pageTitle={
              stateForRender?.social_info?.hero_section_title ||
              stateForRender?.display_name
            }
          />

          <iframe
            src={getIframeURL({
              templateName: templateKey,
              themeName: stateForRender?.themeSlug,
              subDomain: initialState?.sub_domain,
            })}
            title="Preview of your webpage"
            className={`${style.pageFrame} ${
              device === DEVICES.DESKTOP ? "" : style.mobileFrame
            }`}
            id="pageFrame"
            onLoad={handleFrameLoad}
          ></iframe>
          <Fab
            className={style.previewFab}
            variant="extended"
            color="primary"
            onClick={handleScrollToPreview}
          >
            <SmartphoneIcon />
          </Fab>
          <WhiteLabeledFooter
            textLabel={WHITELABELED_FOOTER.PURCHASE_MESSAGE}
            className="tw-absolute tw-left-0 tw-right-0 tw-mx-auto"
            whiteLabelModalHeading={
              UNLOCK_WHITELABELED_MESSAGES.HOME_PAGE_MESSAGE
            }
          />
        </div>
      ) : null}
    </div>
  );
};

export default RenderHostPage;
